import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class names safely. Used by every shadcn/ui component so
 * consumers can override styles without worrying about class precedence.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
